import { withoutDuplicateValues } from "./WithoutDuplicateValues.function";

export function withoutDuplicatePageResponsesFactory() {
    return withoutDuplicateValues((page) => page.UserResponseId);
}
